import { isOkthxAssistant } from "@/components/ui/avatar.tsx";
import { useCurrentUserContext } from "@/hooks/useUser.tsx";

export type AssistantFlags = {
  /** The participant is the assistant (canonical okthx address or the user's
   *  own plus-addressed alias). Drives the non-deletable, "Okthx"-labeled pill. */
  isAssistant: boolean;
  /** The assistant is specifically the current user's own assistant alias. */
  isOwnAssistant: boolean;
};

/**
 * Shared assistant detection for artifact participant blocks. Returns a
 * resolver so a block can flag many participants from one hook call. Reused by
 * every artifact that renders participant pills (email recipients, direct/text
 * message, invitations) so assistant handling stays consistent across types
 * rather than each block re-deriving it.
 */
export const useAssistantFlags = (): ((value: string | undefined) => AssistantFlags) => {
  const { userContext } = useCurrentUserContext();
  const ownAlias = userContext?.user.assistantUserAlias;
  return (value) => {
    const isOwnAssistant = value != null && value === ownAlias;
    return { isOwnAssistant, isAssistant: isOwnAssistant || isOkthxAssistant(value) };
  };
};
